// extracted by mini-css-extract-plugin
module.exports = {"box":"TextStackBody--box--2a8F4","max_width":"TextStackBody--max_width--3jAxu"};